/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';
import { OutfitLayer, WardrobeItem } from '../types';
import { Trash2Icon } from './icons';

interface OutfitStackProps {
  outfitHistory: OutfitLayer[];
  onRemoveLastGarment: () => void;
  onBuyNow: (item: WardrobeItem) => void;
}

const OutfitStack: React.FC<OutfitStackProps> = ({ outfitHistory, onRemoveLastGarment, onBuyNow }) => {
  return (
    <div className="flex flex-col">
      <h2 className="text-xl font-serif tracking-wider text-gray-800 border-b border-gray-400/50 pb-2 mb-3">Outfit Layers</h2>
      <div className="space-y-2">
        {outfitHistory.map((layer, index) => {
          const isLastItem = index > 0 && index === outfitHistory.length - 1;
          return (
            <div
              key={layer.garment?.id || 'base'}
              className="flex items-center justify-between bg-white/50 p-2 rounded-lg animate-fade-in border border-gray-200/80"
            >
              <div className="flex items-center overflow-hidden gap-3">
                <span className="flex-shrink-0 flex items-center justify-center w-6 h-6 text-xs font-bold text-gray-600 bg-gray-200 rounded-full">
                  {index + 1}
                </span>
                {Object.values(layer.poseImages).length > 0 ? (
                  <img
                    src={Object.values(layer.poseImages)[0]}
                    alt="Try-on Result"
                    className="flex-shrink-0 w-12 h-12 object-cover rounded-md border border-gray-200"
                  />
                ) : layer.garment ? (
                  <img src={layer.garment.url} alt={layer.garment.name} className="flex-shrink-0 w-12 h-12 object-cover rounded-md" />
                ) : null}
                <div className="flex flex-col overflow-hidden">
                  <span className="font-semibold text-gray-800 truncate" title={layer.garment?.name}>
                    {layer.garment ? layer.garment.name : 'Base Model'}
                  </span>
                  {/* {layer.garment?.price && (
                    <span className="text-sm font-medium text-gray-700">{layer.garment.price} SAR</span>
                  )} */}
                </div>
              </div>
              {isLastItem && layer.garment && (
                <div className="flex items-center flex-shrink-0 gap-1">
                  {/* <button
                    onClick={() => onBuyNow(layer.garment!)}
                    className="text-sm font-semibold bg-gray-800 text-white px-3 py-2 rounded-md hover:bg-gray-700 transition-colors"
                    aria-label={`Buy ${layer.garment?.name}`}
                  >
                    Buy Now
                  </button> */}
                  <button
                    onClick={onRemoveLastGarment}
                    className="text-gray-500 hover:text-red-600 transition-colors p-2 rounded-md hover:bg-red-50"
                    aria-label={`Remove ${layer.garment?.name}`}
                  >
                    <Trash2Icon className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          )
        })}
        {outfitHistory.length === 1 && (
          <p className="text-center text-sm text-gray-500 pt-4">Your outfit layers will appear here. Start by picking an item from the catalog below.</p>
        )}
      </div>
    </div>
  );
};

export default OutfitStack;
